export default __webpack_public_path__ + "static/reviews-img01-03b76df7341741d73ca3d29905e6d064.png";